import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import DashboardLayout from '../Common/Layouts/DashboardLayout';
import SymbolSearchBox from '../Common/Market/SymbolSearchBox';
import LiveChartBox from './LiveChartBox';
import TradingSignalBox from '../Common/Market/TradingSignalBox';
import SignalHistoryBox from '../Common/Market/SignalHistoryBox';
import SignalTicker from '../Common/Market/SignalTicker';
import SmartCardAuthModal from '../../smartcard/SmartCardAuthModal';
import SeoMeta from '../../SEO/SeoMeta';
import ComingSoonModal from "../../../components/common/ComingSoonModal"; // Make sure path is correct!

export default function LiveMarketPage() {
  const [symbol, setSymbol] = useState('OANDA:XAUUSD');
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);
  

  useEffect(() => {
    const showFromSession = sessionStorage.getItem('show/smartcard-auth') === 'true' || searchParams.get('auth') === 'true';
    if (showFromSession) {
      setShowAuthModal(true);
      sessionStorage.removeItem('show/smartcard-auth');
    }
  }, [searchParams]);

  const handleCloseModal = () => {
    setShowAuthModal(false);
    searchParams.delete('auth');
    navigate('/dashboard/live-market');
  };

    const handleModalClose = () => {
    setShowModal(false);
    navigate("/"); // Change "/" to your landing page route if different
  };

  return (
    <>
      <SeoMeta 
        title="Live Market — Million2Trillion (M2T)" 
        description="Analyze live markets, search any trading symbol, view signals, and monitor real-time charts inside Million2Trillion's professional trading dashboard." 
        url="https://million2trillion.com/dashboard/live-market" 
      />

      <div className="relative">
        <div className={`${showAuthModal ? 'blur-sm pointer-events-none' : ''} transition-all duration-300`}>
          <DashboardLayout>
            <div className="space-y-6">
              <LiveChartBox symbol={symbol} />
              <SymbolSearchBox currentSymbol={symbol} onChange={setSymbol} />
              <TradingSignalBox symbol={symbol} />
              <SignalTicker />
            </div>
          </DashboardLayout>
        </div>
<ComingSoonModal open={showModal} onClose={handleModalClose} />
 
      </div>
    </>
  );
}


